/**
 * "Does this user have full access to their company?"
 *
 * The app used to answer this by comparing `usertype_lbl` to the literal string
 * 'Full Admin' in ~38 places. That is a role NAME, so it silently returns false
 * for a company's actual owner whenever they sit on a differently named role —
 * an owner on "Admin", or on the "Owner" role from the permissions matrix. The
 * symptom is subtle: menus disappear and pages stop opening, with no error.
 *
 * The server now decides this once (User::isInAppAdmin(), which covers the
 * configured admin role ids, the owner of the company's `profiles` row, and any
 * role created from the Owner template) and sends it as `is_full_admin`.
 *
 * The `usertype_lbl` fallback matters: sessions that logged in before this
 * shipped have a cached user object with no `is_full_admin` field, and without
 * the fallback every one of them would be demoted until they signed in again.
 */
export function isFullAdmin(user: any): boolean {
    if (!user) return false;
    if (user.is_full_admin === true) return true;
    if (user.is_company_owner === true) return true;

    // Legacy fallback for sessions predating the server-side flag.
    return user.usertype_lbl === 'Full Admin';
}

/** Convenience for the many call sites that only have the Vuex store to hand. */
export function isFullAdminUser(store: any): boolean {
    return isFullAdmin(store?.getters?.isLoggedIn?.user);
}
